/* eslint-disable camelcase */
import React from "react";
import { useTranslation } from "ceco-polyglot";
import { ActionsTable } from "ceco-window-table";
import { UnitsDeleteModal } from "../../modals/UnitsDeleteModal";
import { UnitModal } from "../../modals/UnitModal";
import { MoreHorizontal, Edit, Delete } from "ceicons";
import DropDownButton from "../../DropDownButton";

import "./unitsTable.scss";

export default function UnitsTable(props) {
  const { unitsParsed, totalCount, _refetch, handleScroll } = props;
  const t = useTranslation();
  const columnsTable = [
    {
      key: "code",
      basis: 1,
      width: 200,
      title: t("table-header.name"),
      ItemRenderer: NameCell,
    },
    {
      key: "description",
      basis: 1,
      title: t("table-header.description"),
    },
    {
      width: 100,
      ItemRenderer: <EditCell refetchData={_refetch} />,
    },
  ];

  return (
    <ActionsTable
      actions={[]}
      allowItemSelection={false}
      footer={
        <div>
          <div className="legend" />
        </div>
      }
      allowAllItemsSelection={false}
      gridActions={[
        <div className="right floated" key="right-side">
          <strong>
            {totalCount} {t("count.units")}
          </strong>
        </div>,
      ]}
      items={unitsParsed}
      columns={columnsTable}
      flags={unitsParsed}
      onScrollTable={handleScroll}
    />
  );
}

const NameCell = (props) => {
  const { rowIndex, style, data } = props;
  const { flags } = data;

  return (
    <div
      role="cell"
      style={{
        ...style,
        flexGrow: 1,
        flexDirection: "row",
        border: "",
      }}
      className="cell"
    >
      <p className="name">{flags[rowIndex].code}</p>
    </div>
  );
};

const EditCell = (props) => {
  const { data, rowIndex, style, refetchData } = props;
  const { flags } = data;
  const { id } = flags[rowIndex];
  const t = useTranslation();

  return (
    <div
      role="cell"
      style={{
        ...style,
        flexGrow: 1,
        flexDirection: "row",
        padding: "1em",
        border: "",
      }}
      className="edit cell"
    >
      <DropDownButton icon={<MoreHorizontal />}>
        <UnitModal
          unit={flags[rowIndex]}
          refetchData={refetchData}
          edit
          trigger={
            <div>
              <Edit />
              <p>{t("popup.edit")}</p>
            </div>
          }
        />
        <UnitsDeleteModal
          unit={flags[rowIndex]}
          unitId={id}
          refetchData={refetchData}
          trigger={
            <div className="delete-modal">
              <Delete />
              <p>{t("popup.remove")}</p>
            </div>
          }
        />
      </DropDownButton>
    </div>
  );
};
